module.exports = function(){ /* empty */ };